import {ConstantsService} from "../ConstantsService";
import {VendasPedidoService} from "../../services/vendas-pedido.service";
import {PedidosService} from "../../services/pedidos.service";
import {GridPedidosComponent} from "../../pedidos/grid-pedidos/grid-pedidos.component";
import {CuponsService} from "../../superadmin/services/cupons.service";
import {ImpressaoService} from "../../services/impressao.service";
import {Component, OnInit, ViewChild} from "@angular/core";

import {ActivatedRoute, Router} from "@angular/router";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {
  aggregateBy,
  AggregateDescriptor,
  AggregateResult, GroupDescriptor,
  orderBy,
  process,
  SortDescriptor
} from "@progress/kendo-data-query";
import {ExcelExportData} from "@progress/kendo-angular-excel-export";
import {RedesService} from "../../services/redes.service";
import {ProcessadorReciboTexto} from "../../services/impressao/ProcessadorReciboTexto";
import {PromocoesService} from "../../compartilhado/services/promocoes.service";
import {SelectEvent} from "@progress/kendo-angular-layout";
import {EmpresasService} from "../../superadmin/services/empresas.service";

declare var moment;
@Component({
  selector: 'app-financeiro-delivery-v2',
  templateUrl: './financeiro-delivery-v2.component.html',
  styleUrls: ['./financeiro-delivery-v2.component.scss']
})
export class FinanceiroDeliveryV2Component implements OnInit {
  @ViewChild('gridPedidos', { static: false}) gridPedidos: GridPedidosComponent;
  filtro: any = {pagos: true, naoPagos: false, delivery: true, mesa: false};
  abaPrincipalAtiva: 'loja' | 'vendas' | 'produtos' | 'combinacoesProdutos' | 'cupons' | 'promocoes' | 'formas' | 'formasEntrega' | 'garcons' = 'vendas';

  empresa: any = {};
  resumoVendas: any = {
    empresa: this.empresa,
    dataInicial: this.filtro.inicio,
    dataFinal: this.filtro.fim,
    total: 0,
    totalComTaxa: 0,
    totalPagamentosComTaxa: 0,
    taxaDeEntrega: 0,
    totalTaxaFormaPagamento: 0,
    qtde: 0,
    qtdeLinhas: 0,
    ticketMedio: 0,
    formasDePagamento:  [],
    formasDeEntrega:  [],
    cupons:  [],
    lojas:  [],
    diarias: [],
    promocoes: []
  }
  resumoProdutos: any = {
    produtos: [],
    carregando: false,
    totalDescontos: 0
  }
  resumoCupons: any = {
    cupons: [],
    carregando: false
  }

  resumoPromocoes: any = {
    promocoes: [],
    carregando: false
  }
  resumoCombinacoes: any = {
    qtdeTotal: 0,
    totalAdicionais: 0,
    combinacoes: [],
    carregando: false
  }
  hoje: Date = new Date();
  dataAtual = null;
  valorMes: Date;
  carregando: boolean;
  vendasDoDia: any;
  vendasProduto: any;
  vendasProdutoAbaAtiva: 'adicionais' | 'combinacoes' = 'adicionais';
  resumoCombinacoesProduto: any = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [] };
  carregandoAdicionaisProduto = false;
  carregandoCombinacoesProduto = false;
  combinacoesProdutoCarregadas = false;
  cupons = []
  garcons = [];
  promocoes = []

  configImpressao: any;
  rede = false;
  usuario: any = null;
  carregandoResumoFormaPagamento: boolean
  resumoPorFormasPagamento: any = []
  sortCupom:  SortDescriptor[] = [{dir: 'desc', field: 'qtde'}  ];
  sortLoja:  SortDescriptor[] = [{dir: 'desc', field: 'qtde'}  ];
  vendasCuponsResultSet: any
  vendasPromocoesResultSet: any
  vendasLojasResultSet: any
  redes: any = [];
  periodoEspecifico: boolean;

  resumoGarcons: any = {
    garcons: [],
    carregando: false
  }

  public aggregates: AggregateDescriptor[] = [
    { field: "qtde", aggregate: "sum" },
    { field: "total", aggregate: "sum" },
    { field: "totalDesconto", aggregate: "sum" },
  ];

  groupable: any = { showFooter: true };
  public group: GroupDescriptor[] = [
    { field: "Produtos", aggregates: this.aggregates },
  ];

  totalCupons: AggregateResult;
  timeoutCarregandoResumo: NodeJS.Timer;
  sortPromocoes: SortDescriptor[] =  [{dir: 'desc', field: 'qtde'}  ];
  totalPromocoes: AggregateResult;

  balcao = false;

  // V2: novas propriedades
  quickDateFilter: 'hoje' | 'ontem' | '7dias' | '30dias' | 'mes' | 'mesAnterior' | 'personalizado' = 'mes';
  mostrarFiltrosAvancados = false;
  chartLabels: string[] = [];
  chartDiasUteis: number[] = [];
  chartFimSemana: number[] = [];

  constructor(private router: Router, private constantsService: ConstantsService,
              private vendasService: VendasPedidoService, private pedidosService: PedidosService,
              private  cuponsService: CuponsService, private impressaoService: ImpressaoService,
              private promocoesService: PromocoesService,  private empresaService: EmpresasService,
              private autorizacaoService: AutorizacaoService, private redesService: RedesService) {

    this.rede = this.router.url.indexOf('/admin-rede') >= 0;

    if( this.router.url.indexOf('/financeiro-balcao') >= 0)
      this.balcao  = true;

    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if(empresa) {
        this.empresa = empresa
        this.configImpressao = this.empresa.configImpressao;
      }
    });

    this.usuario = this.autorizacaoService.getUser();

    if(this.rede )
      this.redes = this.redesService.redesEmpresa();

    this.periodoEspecifico = true;
  }

  ngOnInit(): void {
    this.filtro.inicio = moment().startOf('month').toDate();
    this.filtro.fim = moment().endOf('day').toDate();
    this.carregueResumoVendas();
  }

  onPeriodoAlterado(evento: {inicio: Date, fim: Date, quickDateFilter: string}) {
    this.filtro.inicio = evento.inicio;
    this.filtro.fim = evento.fim;
    this.quickDateFilter = evento.quickDateFilter as any;
    this.abaPrincipalAtiva = this.rede ? 'loja' : 'vendas';
    this.carregueResumoVendas();
  }

  toggleFiltrosAvancados() {
    this.mostrarFiltrosAvancados = !this.mostrarFiltrosAvancados;
  }

  // V2: Preparar dados do grafico
  prepareChartData() {
    this.chartLabels = [];
    this.chartDiasUteis = [];
    this.chartFimSemana = [];

    if (!this.resumoVendas.diarias || this.resumoVendas.diarias.length <= 1) return;

    const diariasOrdenadas = [...this.resumoVendas.diarias].sort((a: any, b: any) =>
      moment(a.dia, 'DD/MM/YYYY').valueOf() - moment(b.dia, 'DD/MM/YYYY').valueOf()
    );

    diariasOrdenadas.forEach((resumoDia: any) => {
      const data = moment(resumoDia.dia, 'DD/MM/YYYY');
      const diaSemana = data.day();
      const isWeekend = diaSemana === 0 || diaSemana === 6;
      const valor = resumoDia.totalComTaxa || resumoDia.total || 0;

      this.chartLabels.push(data.format('DD/MM'));

      if (isWeekend) {
        this.chartDiasUteis.push(null);
        this.chartFimSemana.push(valor);
      } else {
        this.chartDiasUteis.push(valor);
        this.chartFimSemana.push(null);
      }
    });
  }

  // --- Logica original preservada ---

  async carregueResumoFormas() {
    return new Promise((resolve, reject) => {
      if(!this.resumoPorFormasPagamento.length)  {
        this.carregandoResumoFormaPagamento = true;

        let filtro: any = this.obtenhaFiltro();
        filtro.agfp = true;

        this.vendasService.obtenhaResumo(filtro).then( (resposta) => {
          this.resumoPorFormasPagamento = resposta.formasDePagamento || [];
          this.resumoVendas.formasDePagamento =  this.resumoPorFormasPagamento;
          this.carregandoResumoFormaPagamento = false;
          resolve('');
        }).catch((erro) => {
          this.carregandoResumoFormaPagamento = false;
          alert(erro); reject()
        })
      } else {
        resolve('');
      }
    });
  }

  public mudouValorMes(mes: Date) {
    this.filtro.inicio = moment(mes).startOf('month').toDate();
    this.filtro.fim = moment(mes).endOf('month').toDate();
    this.carregueResumoVendas();
  }

  public carregueResumoVendas() {
    if(this.carregando)
      clearTimeout(this.timeoutCarregandoResumo)

    this.carregando = true;

    this.timeoutCarregandoResumo = setTimeout(() => {
      this.vendasService.obtenhaResumo(this.obtenhaFiltro()).then( (resposta) => {
        this.carregando = false;
        this.resumoVendas = resposta;
        this.resumoProdutos = { produtos: [], totalDescontos: 0 };
        this.resumoCombinacoes = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [], carregando: false };
        this.resumoPorFormasPagamento =  [];
        this.resumoGarcons = { garcons: [], carregando: false };
        delete this.vendasDoDia;
        delete this.vendasProduto;
        this.vendasCuponsResultSet = orderBy(process(this.resumoVendas.cupons, {}).data, this.sortCupom);
        this.vendasPromocoesResultSet = orderBy(process(this.resumoVendas.promocoes, {}).data, this.sortPromocoes);
        this.totalCupons = aggregateBy(this.resumoVendas.cupons, this.aggregates);
        this.totalPromocoes = aggregateBy(this.resumoVendas.promocoes, this.aggregates);

        if(this.resumoVendas.lojas)
          this.vendasLojasResultSet = orderBy(process(this.resumoVendas.lojas, {}).data, this.sortLoja);

        this.cuponsService.listeCupons( {}).then( (cupons => {
          this.cupons = cupons || [];
        }))

        this.promocoesService.listePromocoes({}).then((promocoes => {
          this.promocoes = promocoes || [];
        }))

        try {
          this.prepareChartData();
        } catch(e) {
          console.error('Erro ao preparar grafico:', e);
        }

        setTimeout( () => {
          if(this.abaPrincipalAtiva === 'produtos')
            this.carregueResumoProdutos()
          else if(this.abaPrincipalAtiva === 'combinacoesProdutos')
            this.carregueResumoCombinacoes();

          this.empresaService.listeGarcons(this.empresa).then((res: any) => {
            this.garcons = res.data;
          })
        }, 0)
      }).catch((erro) => {
        this.carregando = false;
        console.error('Erro ao carregar resumo vendas:', erro);
      })
      }, 1000)
  }

  private carregueResumoGarcons() {
    this.resumoGarcons.carregando = true;

    this.vendasService.obtenhaResumoGarconsVendas(this.obtenhaFiltro()).then((resposta) => {
      this.resumoGarcons.carregando = false;
      this.resumoGarcons = resposta;
    }).catch((erro) => {
      this.resumoGarcons.carregando = false;
      alert(erro);
    })
  }

  public carregueResumoProdutos() {
   if(!this.filtro.porAdicionais){
     this.group[0].field = 'Produtos'
     this.resumoProdutos.carregando = true;
     this.vendasService.obtenhaResumoPrudutos(this.obtenhaFiltro()).then( (resposta) => {
       this.resumoProdutos.carregando = false;
       this.resumoProdutos = resposta;
     }).catch((erro) => {
       this.resumoProdutos.carregando = false;
       console.error('Erro ao carregar produtos:', erro);
     })
   }  else {
     this.group[0].field = 'Adicionais'
     this.resumoProdutos.carregando = true;
     this.vendasService.obtenhaResumoAdicionais(this.obtenhaFiltro()).then( (resposta) => {
       this.resumoProdutos.carregando = false;
       this.resumoProdutos = resposta;
       this.resumoProdutos.produtos = resposta.adicionais;
     }).catch((erro) => {
       this.resumoProdutos.carregando = false;
       console.error('Erro ao carregar adicionais:', erro);
     })
   }
  }

  public carregueResumoCombinacoes() {
    if(this.resumoCombinacoes.carregando) return;
    if(this.resumoCombinacoes.combinacoes && this.resumoCombinacoes.combinacoes.length) return;

    this.resumoCombinacoes.carregando = true;

    this.vendasService.obtenhaResumoAdicionaisCombinacoes(this.obtenhaFiltro()).then((resposta: any) => {
      const combinacoes = (resposta?.combinacoes || []).slice();
      combinacoes.sort((a: any, b: any) => Number(b.qtde || 0) - Number(a.qtde || 0));

      this.resumoCombinacoes = {
        qtdeTotal: Number(resposta?.qtdeTotal || 0),
        totalAdicionais: Number(resposta?.totalAdicionais || 0),
        combinacoes: combinacoes,
        carregando: false
      };
    }).catch((erro) => {
      this.resumoCombinacoes.carregando = false;
      alert(erro);
    });
  }

  obtenhaFiltro(){
    let dados: any = {}

    if(this.balcao) dados.bal  = true;
    else dados.delivery  =  true

    let dtInicio = this.filtro.inicio ?  moment(this.filtro.inicio).format('YYYYMMDD HH:mm:ss') : null;
    let dtFim = this.filtro.fim ? moment(this.filtro.fim).format('YYYYMMDD HH:mm:ss') : null;

    let formaDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0 ?
      this.filtro.formasDePagamento.map( forma => forma.id).join(',') : null;

    let cupons = this.filtro.cupons && this.filtro.cupons.length > 0 ?
      this.filtro.cupons.map( cupon => this.rede ? cupon.codigo : cupon.id).join(',') : null;

    let promocoes = this.filtro.promocoes && this.filtro.promocoes.length > 0 ?
      this.filtro.promocoes.map( promocao => promocao.id).join(',') : null;

    if(dtInicio) dados.di = dtInicio;
    if(dtFim) dados.df = dtFim;
    if(this.rede)   dados.r = 1;
    if(this.filtro.rede) dados.rid = this.filtro.rede.id;

    if(formaDePagamento) dados.fp = formaDePagamento;
    if(cupons){
      if(this.rede)
        dados.ccps = cupons;
      else
        dados.cps = cupons;
    }

    if(promocoes)
      dados.prs = promocoes;

    if(this.filtro.formaDeEntregaEmpresa) dados.fe = this.filtro.formaDeEntregaEmpresa.formaDeEntrega.id;

    let garcons = this.filtro.garcons && this.filtro.garcons.length > 0 ?
      this.filtro.garcons.map( garcom => garcom.id).join(',') : null;

    if(garcons) dados.gs = garcons;

    if(this.filtro.pagos) dados.pg = 1;
    if(this.filtro.naoPagos) dados.np = 1;
    if(this.filtro.mesa) dados.ms = 1;
    if(this.filtro.balcao) dados.bl = 1;
    if(this.filtro.delivery) dados.dl = 1;

    return dados;
  }

  verPedidos(resumoDia: any) {
    this.vendasDoDia = resumoDia;
    if(this.vendasDoDia.pedidos && this.vendasDoDia.pedidos.length) return;

    this.vendasDoDia.carregando = true;

    let dia = moment(this.vendasDoDia.dia, 'DD/MM/YYYY').format('YYYYMMDD')
    let formaDeEntrega = this.filtro.formaDeEntregaEmpresa ? this.filtro.formaDeEntregaEmpresa.formaDeEntrega : null;
    let formasDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0 ?
      this.filtro.formasDePagamento.map( forma => forma.id)  : null;

    let cupons = this.filtro.cupons && this.filtro.cupons.length > 0 ?
      this.filtro.cupons.map( cupon => cupon.id) : null;

    let promocoes = this.filtro.promocoes && this.filtro.promocoes.length > 0 ?
      this.filtro.promocoes.map( promocao => promocao.id) : null;

    let params: any = {
      dtInicio: dia, dtFim: dia,
      destino: 'delivery',
      formaDeEntrega: formaDeEntrega,
      formasDePagamento: formasDePagamento,
      cupons: cupons,
      promocoes: promocoes
    };

    if(this.filtro.mesa){
      if(this.filtro.delivery)
        delete params.destino
      else params.delivery = 'mesas'
    } else if(this.filtro.balcao){
      if(this.filtro.delivery)
        delete params.destino
      else params.delivery = 'balcao'
    }

    if( this.rede ) {
      params.r = 1;
    }

    if(this.filtro.pagos && this.filtro.naoPagos ) {
      params.pagosENaoPagos = true
    } else if(this.filtro.pagos){
      params.apenasPagos  = true
    } else if(this.filtro.naoPagos){
      params.naoPagos  = true
    }

    this.pedidosService.listePedidos(0, 10000, params).then( (resposta) => {
      this.vendasDoDia.pedidos = resposta ? (resposta.pedidos || []) : [];
      this.vendasDoDia.carregando = false;

      this.gridPedidos.atualizeGridPedidos(this.vendasDoDia.pedidos, String(`dia ${dia}`));
    }).catch( () => {
      this.vendasDoDia.carregando = false;
    });
  }

  verDetalhesVendasProduto(resumoProduto: any) {
    this.vendasProduto = resumoProduto;
    this.vendasProdutoAbaAtiva = 'adicionais';
    this.resumoCombinacoesProduto = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [] };
    this.carregandoAdicionaisProduto = false;
    this.combinacoesProdutoCarregadas = false;
    this.carregandoCombinacoesProduto = false;

    if(!this.vendasProduto.adicionais){
      this.carregandoAdicionaisProduto = true;
      this.vendasService.obtenhaResumoAdicionaisPruduto(this.vendasProduto.id, this.obtenhaFiltro()).then( (resposta) => {
         this.vendasProduto.adicionais = resposta?.adicionais || [];
         this.carregandoAdicionaisProduto = false;
      }).catch((erro) => {
        this.carregandoAdicionaisProduto = false;
        alert(erro);
      });
    }
  }

  selecionouTabDetalheProduto($event: SelectEvent) {
    if($event.title.indexOf('Combinações') >= 0){
      this.vendasProdutoAbaAtiva = 'combinacoes';
      this.carregueResumoCombinacoesProduto();
      return;
    }
    this.vendasProdutoAbaAtiva = 'adicionais';
  }

  carregueResumoCombinacoesProduto() {
    if(!this.vendasProduto || this.carregandoCombinacoesProduto || this.combinacoesProdutoCarregadas)
      return;

    this.carregandoCombinacoesProduto = true;

    this.vendasService.obtenhaResumoAdicionaisCombinacoesProduto(this.vendasProduto.id, this.obtenhaFiltro()).then((resposta: any) => {
      this.carregandoCombinacoesProduto = false;
      this.combinacoesProdutoCarregadas = true;

      const combinacoes = (resposta?.combinacoes || []).slice();
      combinacoes.sort((a: any, b: any) => Number(b.qtde || 0) - Number(a.qtde || 0));

      this.resumoCombinacoesProduto = {
        qtdeTotal: Number(resposta?.qtdeTotal || 0),
        totalAdicionais: Number(resposta?.totalAdicionais || 0),
        combinacoes: combinacoes
      };
    }).catch((erro) => {
      this.carregandoCombinacoesProduto = false;
      alert(erro);
    });
  }

  async selecionouTab($event: SelectEvent) {
    this.atualizeAbaPrincipalAtiva($event);

    if($event.title.indexOf('Produtos') >= 0  && ( !this.resumoProdutos.produtos || !this.resumoProdutos.produtos.length))
      this.carregueResumoProdutos();

    if($event.title.indexOf('Combinações') >= 0 && (!this.resumoCombinacoes.combinacoes || !this.resumoCombinacoes.combinacoes.length))
      this.carregueResumoCombinacoes();

    if($event.title.indexOf('Garçom') >= 0 && (!this.resumoGarcons.garcons || !this.resumoGarcons.garcons.length))
      this.carregueResumoGarcons();

    if($event.title.indexOf('Formas') >= 0)
     await this.carregueResumoFormas();
  }

  private atualizeAbaPrincipalAtiva($event: SelectEvent) {
    const titulo = String($event.title || '').toLowerCase();

    if(titulo.indexOf('por loja') >= 0) { this.abaPrincipalAtiva = 'loja'; return; }
    if(titulo.indexOf('vendas diárias') >= 0 || titulo.indexOf('vendas diarias') >= 0) { this.abaPrincipalAtiva = 'vendas'; return; }
    if(titulo.indexOf('por produtos') >= 0) { this.abaPrincipalAtiva = 'produtos'; return; }
    if(titulo.indexOf('combinações') >= 0 || titulo.indexOf('combinacoes') >= 0) { this.abaPrincipalAtiva = 'combinacoesProdutos'; return; }
    if(titulo.indexOf('por cupons') >= 0) { this.abaPrincipalAtiva = 'cupons'; return; }
    if(titulo.indexOf('por promoções') >= 0 || titulo.indexOf('por promocoes') >= 0) { this.abaPrincipalAtiva = 'promocoes'; return; }
    if(titulo.indexOf('formas de pagamento') >= 0) { this.abaPrincipalAtiva = 'formas'; return; }
    if(titulo.indexOf('formas entrega') >= 0) { this.abaPrincipalAtiva = 'formasEntrega'; return; }
    if(titulo.indexOf('garçom') >= 0 || titulo.indexOf('garcom') >= 0) { this.abaPrincipalAtiva = 'garcons'; }
  }

  voltarVendasDia() {
    delete this.vendasDoDia;
  }

  voltarVendasProdutos(){
    delete this.vendasProduto;
    this.vendasProdutoAbaAtiva = 'adicionais';
    this.resumoCombinacoesProduto = { qtdeTotal: 0, totalAdicionais: 0, combinacoes: [] };
    this.carregandoAdicionaisProduto = false;
    this.combinacoesProdutoCarregadas = false;
    this.carregandoCombinacoesProduto = false;
  }

  obtenhaDescricaoFiltro() {
    if(moment(this.filtro.inicio).isSame(moment(this.filtro.fim), 'day'))
      return String(` do dia ${moment(this.filtro.inicio).format('DD/MM/YYYY')}`)

    return  String(`entre ${moment(this.filtro.inicio).format('DD/MM/YYYY')} e  ${moment(this.filtro.fim).format('DD/MM/YYYY')}`);
  }

  obtenhaNomeArquivo() {
    let sufixo = this.vendasProduto ? this.vendasProduto.nome.replace(/\s/g, '-') : '';
    return String(`produtos-adicionais-${sufixo}.xls`)
  }

  obtenhaNomeArquivoCombinacoes() {
    let sufixo = this.vendasProduto ? this.vendasProduto.nome.replace(/\s/g, '-') : '';
    return String(`produtos-adicionais-combinacoes-${sufixo}.xls`)
  }

  obtenhaNomeArquivoCombinacoesGeral() {
    return this.obtenhaNomeArquivoDownload('vendas-adicionais-combinacoes');
  }

  obtenhaNomeArquivoDownload(nome: string) {
    let inicio =  moment(this.filtro.inicio).format('DD-MM-YYYY');
    let fim =  moment(this.filtro.fim).format('DD-MM-YYYY');

    if(this.filtro.rede)
      nome = String(`${nome}-${this.filtro.rede.nome.toLowerCase()}`)

    let sufixo = String(`${inicio}_e_${fim}`)

    return String(`${nome}(${sufixo}).xls`)
  }

  imprimaRelatorio(impressora: any = null) {
    if(this.configImpressao && this.configImpressao.imprimirTXT)
      return this.imprimaNativamente(this.configImpressao.impressoras[0]);

    let link = '/imprimir/relatorio/delivery'
    let query = []

    if(this.filtro.inicio) query.push('inicio=' + moment(this.filtro.inicio).format('YYYYMMDD HH:mm:ss'))
    if(this.filtro.fim) query .push('fim=' + moment(this.filtro.fim).format('YYYYMMDD HH:mm:ss'))

    let formaDePagamento = this.filtro.formasDePagamento && this.filtro.formasDePagamento.length > 0 ?
      this.filtro.formasDePagamento.map( forma => forma.id).join(',') : null;

    let cupons = this.filtro.cupons && this.filtro.cupons.length > 0 ?
      this.filtro.cupons.map( cupon => cupon.id).join(',') : null;

    let promocoes = this.filtro.promocoes && this.filtro.promocoes.length > 0 ?
      this.filtro.promocoes.map( promocao => promocao.id).join(',') : null;

    if(formaDePagamento) query.push('fp=' + formaDePagamento);
    if(cupons) query.push('cps=' + cupons);
    if(promocoes) query.push('prs=' + promocoes);
    if(this.filtro.formaDeEntregaEmpresa) query.push('fe=' + this.filtro.formaDeEntregaEmpresa.formaDeEntrega.id);
    if(this.filtro.naoPagos) query.push('np=1');
    if(this.filtro.delivery) query.push('dl=1');
    if(this.filtro.mesa) query.push('ms=1');

    if(query.length > 0)
      link += '?' + query.join('&')

    window.open(link);
  }

  private async imprimaNativamente(impressora: any) {
    this.resumoVendas.dataInicial = this.filtro.inicio
    this.resumoVendas.dataFinal = this.filtro.fim
    this.resumoVendas.empresa = this.empresa

    await this.carregueResumoFormas();

    if(!impressora) impressora = this.configImpressao.impressoras[0]

    let relatorio: any = new ProcessadorReciboTexto(impressora).obtenhaRelatorio(this.resumoVendas)
    this.impressaoService.imprimaTexto(relatorio, impressora)
  }

  downloadCsvProdutos() {
    let link = '/exportar/vendas/produtos/csv?';
    let filtro = this.obtenhaFiltro();
    Object.keys(filtro).forEach( key => { link  = String(`${link}${key}=${filtro[key]}&`); })
    window.open(link);
  }

  downloadCsvCupons() {
    let link = '/exportar/vendas/cupons/csv?';
    let filtro = this.obtenhaFiltro();
    Object.keys(filtro).forEach( key => { link  = String(`${link}${key}=${filtro[key]}&`); })
    window.open(link);
  }

  downloadCsvPromocoes() {
    let link = '/exportar/vendas/promocoes/csv?';
    let filtro = this.obtenhaFiltro();
    Object.keys(filtro).forEach( key => { link  = String(`${link}${key}=${filtro[key]}&`); })
    window.open(link);
  }

  downloadCsvPromocoesContatos() {
    let link = '/exportar/vendas/promocoes/contatos/csv?';
    let filtro = this.obtenhaFiltro();
    Object.keys(filtro).forEach( key => { link  = String(`${link}${key}=${filtro[key]}&`); })
    window.open(link);
  }

  downloadCsvCuponsContatos(){
    let link = '/exportar/vendas/cupons/contatos/csv?';
    let filtro = this.obtenhaFiltro();
    Object.keys(filtro).forEach( key => { link  = String(`${link}${key}=${filtro[key]}&`); })
    window.open(link);
  }

  sortChange($event: any) {
    this.sortCupom = $event;
    this.vendasCuponsResultSet = orderBy(process(this.resumoVendas.cupons, {}).data, this.sortCupom);
  }

  sortChangeLojas(sort: SortDescriptor[]){
    this.sortLoja = sort;
    this.vendasLojasResultSet = orderBy(process(this.resumoVendas.lojas, {}).data, this.sortLoja);
  }

  sortChangePromocoes(sort: SortDescriptor[]){
    this.sortPromocoes = sort;
    this.vendasPromocoesResultSet = orderBy(process(this.resumoVendas.promocoes, {}).data, this.sortPromocoes);
  }

  public produtosMaisTaxas = (): any  => {
    let myState: any = {};
    let produtos = this.resumoProdutos.produtos;
    produtos.push({})
    myState.skip = 0;
    myState.take = produtos.length;
    const result: ExcelExportData =  {
      data: process(produtos, myState).data
    };
    return result;
  };
}
